import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetUsers,
  serviceGetUser,
  servicePutUser,
  serviceDeleteUser,
  servicePostUser,
} from 'utils';

const initialState = {
  data: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
}

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {

    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpUser() {
      return initialState;
    },

    cleanUpMessageUser(state) {
      return {
        ...state,
        data: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },
  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpUser,
  cleanUpMessageUser,
} = UserSlice.actions;

const fetchGetUser = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetUser(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchGetUsers = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetUsers(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostUser = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostUser(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};

const fetchPutUser = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutUser(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteUser = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteUser(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};


export {
  fetchGetUser,
  fetchGetUsers,
  fetchPostUser,
  fetchPutUser,
  fetchDeleteUser,
  cleanUpUser,
  cleanUpMessageUser
};


export default UserSlice.reducer;